import { render, staticRenderFns } from "./giftRequest.vue?vue&type=template&id=ddf05354"
import script from "./giftRequest.vue?vue&type=script&lang=js"
export * from "./giftRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports